<template>
    <div>

<!-- Footer -->
<footer class="page-footer font-small bg-info  mt-4 pt-4">

    <!-- Footer Links -->
    <div class="container-fluid text-center text-md-left">

      <!-- Grid row -->
      <div class="row">

        <!-- Grid column -->
        <div class="col-md-6 mt-md-0 mt-3">

          <!-- organizacia -->
          <h5 class="text-uppercase">{{mainInfo.enMainInfo.organisation}}</h5>
          <p>{{mainInfo.enMainInfo.orgText}}</p>

        </div>
        <!-- Grid column -->

        <hr class="clearfix w-100 d-md-none pb-3">

        <!-- Grid column -->
        <div class="col-md-3 mb-md-0 mb-3">

            <!-- Links -->
            <h5 class="text-uppercase font-weight-bold">Links</h5>

            <ul class="list-unstyled ">
              <li>
                <a href="#!">Link 1</a>
              </li>
              <li>
                <a href="#!">Link 2</a>
              </li>
              <li>
                <a href="#!">Link 3</a>
              </li>
              <li>
                <a href="#!">Link 4</a>
              </li>
            </ul>

          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-3 mb-md-0 mb-3">

            <!-- Links -->
            <h5 class="text-uppercase font-weight-bold">{{names.enMenuName}}</h5>

            <ul class="list-unstyled ">
            <li v-for="menus in menus"
            class="list-unstyled text-dark">
              <a href="#!" class="text-dark">  {{ menus.enMenu }}</a>
        </li>
            </ul>

          </div>
          <!-- Grid column -->

      </div>
      <!-- Grid row -->

    </div>
    <!-- Footer Links -->

    <!-- Copyright -->
    <div class="footer-copyright text-center bg-dark text-white py-3">© 2019 Copyright:
      <a href=""> Shota Tsiklauri (SHTS)</a>
    </div>
    <!-- Copyright -->

  </footer>
  <!-- Footer -->
       
    </div>
</template>

<script>
export default {
    data(){
        return {
            mainInfo: {
                geMainInfo:
                    {
                    organisation: 'საქართველოს საცხენოსნო სპორტის ფედერაცია',
                    orgText: 'საქართველოში ანვითარებს საცხენოსნო სპორტს'
                    },
                enMainInfo: {
                    organisation: 'Georgian Equestrian Federation',
                    orgText: 'This organization develops in Georgia Equestrian Sport '
                },
                ruMainInfo: {
                    organisation: '',
                    orgText: ''
                }
            },
            names: {
                geMenuName: 'მენიუ',
                enMenuName: 'Menu',
                ruMenuName: ''

            },
            menus: [
                {
                    geMenu: '',
                    enMenu: 'About us',
                    ruMenu: '',
                    geLink: '',
                    enLink: '',
                    ruLink: ''
                },
                {
                    geMenu: '',
                    enMenu: 'News',
                    ruMenu: '',
                    geLink: '',
                    enLink: '',
                    ruLink: ''
                },
                {
                    geMenu: '',
                    enMenu: 'History',
                    ruMenu: '',
                    geLink: '',
                    enLink: '',
                    ruLink: ''
                },
                {
                    geMenu: '',
                    enMenu: 'club & union',
                    ruMenu: '',
                    geLink: '',
                    enLink: '',
                    ruLink: ''
                },
                {
                    geMenu: '',
                    enMenu: 'Turism & adventure',
                    ruMenu: '',
                    geLink: '',
                    enLink: '',
                    ruLink: ''
                },
                {
                    geMenu: '',
                    enMenu: 'Contact Us',
                    ruMenu: '',
                    geLink: '',
                    enLink: '',
                    ruLink: ''
                },
            ]
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/Footer.vue